import { Truck, Fuel, FileCheck2, Building2, Calculator, ShieldCheck, Radio, Wrench, FileText } from "lucide-react";

const MAP = {
  truck: Truck, fuel: Fuel, "file-check": FileCheck2, building: Building2,
  calculator: Calculator, shield: ShieldCheck, radio: Radio, wrench: Wrench,
};

export default function CategoryIcon({ icon, className = "w-6 h-6" }) {
  const Icon = MAP[icon] || FileText;
  return <Icon className={className} />;
}
